import PropTypes from 'prop-types';

import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Button, Text} from '@/src/ui';

import css from '../styles/SuccessMessagePopup.module.css';

const SuccessMessagePopup = ({title, description, onClose}) => {
  return (
    <div className={css.main}>
      <div className={css.content}>
        <div className={css.title}>
          <Text
            fontSize={Text.FONT_SIZE.SIZE_24}
            fontFamily={Text.FONT_FAMILY.RUBIK}
          >
            {title}
          </Text>
        </div>
        <div className={css.description}>
          <Text
            color={Text.COLOR.GREY}
            fontSize={Text.FONT_SIZE.SIZE_14}
            lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_4}
          >
            {description}
          </Text>
        </div>
        <div className={css.button}>
          <Button onClick={onClose} height={Button.HEIGHT.SMALL}>
            <TextLocal id={'wiki-how.close'} />
          </Button>
        </div>
      </div>
    </div>
  );
};

SuccessMessagePopup.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
    .isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SuccessMessagePopup;
